<template>
    <div class="column is-9">
        <section class="hero is-info welcome is-small">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        Certificados
                    </h1>
                    <h2 class="subtitle">
                        En esta sección puede descargar documentos y certificados.
                    </h2>
                </div>
            </div>
        </section>
        <section class="info-tiles">
            <div class="tile is-ancestor has-text-centered">
                <div class="tile is-parent" @click="attemptGetDocument('Cert_Etica', 'document', true)">
                    <article class="tile is-child box is-clickable">
                        <p class="title">Ética</p>
                        <p class="subtitle">Certificado</p>
                    </article>
                </div>
                <div class="tile is-parent" @click="attemptGetDocument('Cert_Matricula', 'document', true)">
                    <article class="tile is-child box is-clickable">
                        <p class="title">Matrícula</p>
                        <p class="subtitle">Certificado</p>
                    </article>
                </div>
            </div>
        </section>
        <section class="info-tiles">
            <div class="tile is-ancestor has-text-centered">
                <div class="tile is-parent" @click="attemptGetDocument('Cert_Libre_Deuda', 'document', true)">
                    <article class="tile is-child box is-clickable">
                        <p class="title">Libre Deuda</p>
                        <p class="subtitle">Certificado</p>
                    </article>
                </div>
                <div class="tile is-parent" @click="attemptGetDocument('DDJJ_Disponibilidad_Horaria_Colegio_TS.pdf', 'file', false)">
                    <article class="tile is-child box is-clickable">
                        <p class="title">Disponibilidad Horaria</p>
                        <p class="subtitle">Declaración Jurada</p>
                    </article>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {isInvalidPeriod} from '../utils/validatePeriod'
export default {
    name: 'dashboard',
    computed: {
        ...mapGetters({
            accountPeriodsOwed: 'accountStatus/accountPeriodsOwed',
            simbolicCuota: 'accountStatus/simbolicCuota',
            isSanctioned: 'auth/isSanctioned'
        }),
    },
    methods:{
        ...mapActions({
            getDocument: 'documents/getDocument',
            setAuthErrors: 'auth/setAuthErrors',
            clearAuthErrors: 'auth/clearAuthErrors'
        }),

        attemptGetDocument(docName, docType, validate){
            let data = { docName, docType };

            if ( this.simbolicCuota ) {
                this.setAuthErrors('Esta cuenta no puede descargar certificados. <strong>Comuníquese con el Colegio.</strong>')
                setTimeout(() => this.clearAuthErrors(), 3000);
            } else if ( isInvalidPeriod(docName, this.accountPeriodsOwed) && validate ) {
                this.setAuthErrors('Esta cuenta no puede descargar certificados ya que posee pagos pendientes. <strong>Comuníquese con el Colegio.</strong>')
                setTimeout(() => this.clearAuthErrors(), 3000);
            } else if ( docName == 'Cert_Etica' && this.isSanctioned ) {
                this.setAuthErrors('Esta cuenta no puede descargar certificados porque posee una sanción ética. <strong>Comuníquese con el Colegio.</strong>')
                setTimeout(() => this.clearAuthErrors(), 3000);
            } else {
                this.getDocument(data)
            }
        }
    }
}
</script>
